import { useTruncate } from "./useTruncate"

const serviceOperations = "We optimise processes, systems, and workflows to maximise efficiency and productivity and deliver exceptional customer experiences, driving growth and success for your business."

const hrTechnology = "We implement cutting-edge HR technologies to attract, develop, and retain top talent, fostering a high-performance culture and enabling data-driven decision-making for your organisation."

const productDevelopment = "We create innovative products that customers love through agile methodologies and build custom digital solutions to transform businesses, accelerate growth, and optimise customer experiences."

const brandDesign = "We craft compelling brand identities that capture your business's essence, resonate with target audiences, and effectively communicate core values through striking visual elements."

const upriseEquity = "Empowering investment portfolio management, the custom-built content management system by Eratek for Uprise Equity, enables streamlined information dissemination."

const eraconneckt = "Eraconneckt is an all-in-one Applicant Tracking System that provides seamless recruitment processes as it empowers African youths."

const mariams = "Indulge in the rich flavours of African cuisine through Mariam's Kitchen, a New York-based kitchen service. Discover authentic African dishes, made with love and passion."

const hrtechish = "Fueling HR Tech innovation, the specialised content management system by Eratek, connecting HR Tech and allied professionals with transformative insights and collaborative opportunities."
const hrtechishSummit = "Join top HR professionals, tech innovators, and forward-thinking leaders at HRTechish Summit—a one-of-a-kind event designed to explore how technology is transforming HR across Africa and beyond."
export const useContent = () => {
  const truncatedServiceOperations = useTruncate(serviceOperations, 200)
  const truncatedHrTech = useTruncate(hrTechnology, 200)
  const truncatedProductDevelopment = useTruncate(productDevelopment, 200)
  const truncatedBrandDesign = useTruncate(brandDesign, 200)
  const truncatedUprise = useTruncate(upriseEquity, 200)
  const truncatedEraconneckt = useTruncate(eraconneckt, 200)
  const truncatedMariams = useTruncate(mariams, 200)
  const truncatedHrTechCms = useTruncate(hrtechish, 200)
    const truncatedHrTechSummit = useTruncate(hrtechishSummit, 200)


  return {
    truncatedBrandDesign,
    truncatedHrTech,
    truncatedProductDevelopment,
    truncatedServiceOperations,
    truncatedUprise,
    truncatedEraconneckt,
    truncatedMariams,
    truncatedHrTechCms,truncatedHrTechSummit
  }
}